export const optionsCivilite = [
  { value: 'M.', label: 'M.' },
  { value: 'Mme.', label: 'Mme.' },
  { value: 'Mlle.', label: 'Mlle.' },
];

export const optionsStatutMarital = [
  { value: 'Marié/Mariée', label: 'Marié/Mariée' },
  { value: 'Pacsé/Pacsée', label: 'Pacsé/Pacsée' },
  { value: 'Célibataire', label: 'Célibataire' },
  { value: 'Veuf/Veuve', label: 'Veuf/Veuve' },
];

export const optionsIndice = [
  { value: 'Aucun', label: 'Aucun' },
  { value: 'Bis', label: 'Bis' },
  { value: 'Ter', label: 'Ter' },
  { value: 'Quarter', label: 'Quarter' },
];

export const optionsActivite = [
  {
    value: 'Location meublée courte durée (location touristique)',
    label: 'Location meublée courte durée (location touristique)',
  },
  {
    value: 'Profession libérale',
    label: 'Profession libérale',
  },
  {
    value: 'Bureaux',
    label: 'Bureaux',
  },
  {
    value: 'Commerce',
    label: 'Commerce',
  },
  {
    value: 'Artisanat',
    label: 'Artisanat',
  },
  {
    value: "Activité d'intérêt collectif",
    label: "Activité d'intérêt collectif",
  },
];

export const optionsStatutDemandeur = [
  {
    value: 'Propriétaire',
    label: 'Propriétaire',
  },
  {
    value: 'Locataire',
    label: 'Locataire',
  },
  {
    value: 'Occupant à titre gratuit',
    label: 'Occupant à titre gratuit',
  },
  {
    value: "Bénéficiaire d'une promesse de vente",
    label: "Bénéficiaire d'une promesse de vente",
  },
];

export const optionsLocalDetient = [
  {
    value: 'Le propriétaire en son nom propre',
    label: 'Le propriétaire en son nom propre',
  },
  {
    value: 'Une société ou une personne morale',
    label: 'Une société ou une personne morale',
  },
];

export const optionsLocalStatut = [
  {
    value: 'Usufruitier',
    label: 'Usufruitier',
  },
  {
    value: 'Nu-propriétaire',
    label: 'Nu-propriétaire',
  },
  {
    value: 'Propriétaire (pleine propriété)',
    label: 'Propriétaire (pleine propriété)',
  },
];
